import React from "react";
import PropTypes from "prop-types";
import NavigatorColumn from "./NavigatorColumn";
import EntityName from "data/util/EntityName";
import buildNavContainer, { navShape } from "./buildNavContainer";

const magicItems = tree => {
    const items = [];
    tree.projections.forEach(p => {
        items.push({
            // one for the projection
            cid: p.implementationKey,
            label: p.implementationName,
            implKey: p.implementationKey,
            nestLevel: 0,
            selected: p.selected,
            expanded: p.expanded,
            childCount: p.childCount,
            type: "impl",
        });
        if (! p.expanded) return;
        p.versions.forEach(v => {
            items.push({
                // one per version
                cid: tree.isMagic ? v.versionKey : v.key,
                label: tree.isMagic ? v.versionName : (v.versionName + " " + v.name),
                implKey: p.implementationKey,
                nestLevel: 1,
                selected: v.selected,
                childCount: v.childCount,
                // passthrough
                type: "record",
                versionKey: v.versionKey,
                entityKey: v.key,
                recordId: tree.id,
            });
        });
    });
    if (tree.isMagic && tree.projections.length > 1) {
        items.push({
            // one for "all"
            cid: "all-impls",
            label: "All Implementations",
            selected: tree.selected,
            childCount: tree.childCount,
            // passthrough
            type: "all-impls",
        });
    }
    return items;
};

const recordItems = field =>
    field.items.map(it => ({
        cid: it.id,
        label: it.label,
        selected: it.selected,
        childCount: it.childCount,
        // passthrough
        type: "record",
        entityKey: it.entityKey,
        recordId: it.id,
        implKey: it.implKey,
    }));

class ColNav extends React.PureComponent {

    constructor(...args) {
        super(...args);
        this.onAddItem = this.onAddItem.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onSelectItem = this.onSelectItem.bind(this);
    }

    onAddItem(container, entityKey) {
        const {
            onAddMagicChild,
            onAddChild,
        } = this.props;
        if (EntityName.is(container.recordKey)) {
            onAddChild(container.recordKey, container.recordId, container.key, entityKey);
        } else {
            onAddMagicChild(container.recordKey, container.recordId, entityKey);
        }
    }

    onRemove(container) {
        const {
            onDeleteChild,
            onDeleteMagicChild,
        } = this.props;
        const item = container.items.find(it => it.selected);
        if (EntityName.is(container.recordKey)) {
            onDeleteChild(
                container.recordKey,
                container.recordId,
                container.key,
                item.entityKey,
                item.id,
            );
        } else {
            onDeleteMagicChild(item.entityKey, item.id);
        }
    }

    onSelectItem(container, item) {
        const {
            onSelectRecord,
            onSelectImpl,
            onSelectAllImpls,
        } = this.props;
        switch (item.type) {
            case "record":
                onSelectRecord(item.entityKey, item.recordId);
                break;
            case "impl":
                onSelectImpl(item.implKey);
                break;
            case "all-impls":
                onSelectAllImpls();
                break;
            default:
                console.warn(`Unrecognized '${item.type}' item selected?`);
                break;
        }
    }

    render() {
        const {
            isSuperRecord,
            tree,
            onExpansionChange,
        } = this.props;
        const columns = [];

        const addMagicRootColumn = tree => columns.push(
            <NavigatorColumn
                key={tree.id}
                ITid={tree.id}
                label={tree.name + " Forms"}
                items={magicItems(tree)}
                active={true}
                showAdd={false}
                showRemove={false}
                onSelectItem={(...args) => this.onSelectItem(tree, ...args)}
                onExpansionChange={onExpansionChange}
            />,
        );

        const addFieldsToColumns = fields => {
            for (const f of fields) {
                addFieldToColumns(f);
                const sel = f.items.find(it => it.selected);
                if (sel != null) {
                    addFieldsToColumns(sel.fields);
                    break;
                }
            }
        };

        const addFieldToColumns = field => {
            const items = recordItems(field);
            return columns.push(
                <NavigatorColumn
                    key={field.key}
                    ITid={field.key}
                    label={field.name}
                    items={items}
                    active={true}
                    showAdd={field.creatables != null && field.creatables.length > 0}
                    creatables={field.creatables.map(c => ({
                        value: c.key,
                        label: c.name,
                        implKey: c.implKey,
                    }))}
                    showRemove={items.some(
                        it => it.selected)}
                    onAddItem={(...args) => this.onAddItem(field, ...args)}
                    onRemove={(...args) => this.onRemove(field, ...args)}
                    onSelectItem={(...args) => this.onSelectItem(
                        field,
                        ...args,
                    )}
                />,
            );
        };

        if (isSuperRecord) {
            addMagicRootColumn(tree);
            addFieldsToColumns(tree.fields);
        } else {
            addFieldsToColumns([tree]);
        }
        return <nav className="entity navigator">
            {columns}
        </nav>;
    }
}

ColNav.propTypes = navShape;

const ColumnNavigator = buildNavContainer(ColNav);

ColumnNavigator.propTypes = {
    fluxContext: PropTypes.string.isRequired,
};

export default ColumnNavigator;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/ColumnNavigator.js